module.exports = __webpack_public_path__ + "img/oa_banner.f32bb60a.png";